import { render } from "./VariantesDetailComponent.vue?vue&type=template&id=ebf7545a&scoped=true"
import script from "./VariantesDetailComponent.vue?vue&type=script&lang=js"
export * from "./VariantesDetailComponent.vue?vue&type=script&lang=js"

import "./VariantesDetailComponent.vue?vue&type=style&index=0&id=ebf7545a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebf7545a"]])

export default __exports__